import { createContext } from 'react';
import { Container } from 'inversify';
export const rootContainer = new Container();
export const ContainerContext = createContext(rootContainer);
export function symbolToken(key, global = true) {
    return global ? Symbol.for(key) : Symbol(key);
}
//# sourceMappingURL=common.js.map